var map = {
	"./addresslist.png": "25d0",
	"./allot.png": "27aa",
	"./assets.png": "db70",
	"./bank.png": "cedb",
	"./car.png": "15cc",
	"./care.png": "20a1",
	"./clue.png": "19d8",
	"./collection.png": "a7ce",
	"./compete.png": "b061",
	"./complaint.png": "5dcb",
	"./contacts.png": "8985",
	"./contract.png": "cb54",
	"./cost.png": "0c63",
	"./crmInvoice.png": "0a35",
	"./crmPay.png": "49b2",
	"./crmReport.png": "875c",
	"./crmResource.png": "958c",
	"./customProductFlow.png": "ece2",
	"./customer.png": "3e05",
	"./cwAccount.png": "a814",
	"./cwCollection.png": "0008",
	"./cwIncome.png": "b7dd",
	"./cwInvoice.png": "73d0",
	"./cwPay.png": "1ebe",
	"./document.png": "1e07",
	"./instock.png": "290b",
	"./inventoryExperiment.png": "f05a",
	"./invooiceReport.png": "e7b1",
	"./maintenance.png": "7c8d",
	"./material.png": "8a89",
	"./materialStock.png": "ee0a",
	"./materialStockTotal.png": "0c7e",
	"./meeting.png": "a370",
	"./news.png": "1b69",
	"./oaEmail.png": "0735",
	"./oaNotice.png": "2ab3",
	"./oaTask.png": "8263",
	"./order.png": "0fef",
	"./outstock.png": "624a",
	"./purchaseContract.png": "53a8",
	"./purchaseInquiry.png": "7e07",
	"./purchaseOrder.png": "52fa",
	"./purchasePayment.png": "95bc",
	"./purchasePlan.png": "8a5f",
	"./purchaseReport.png": "dbad",
	"./purchaseReturn.png": "e9fc",
	"./purchaseSupplier.png": "0bec",
	"./repair.png": "a979",
	"./repairDo.png": "aff0",
	"./return.png": "c723",
	"./schedule.png": "84162",
	"./service.png": "725d",
	"./serviceOrder.png": "8563",
	"./suggested.png": "113e",
	"./visit.png": "0fe0",
	"./warehouse.png": "98c9",
	"./work.png": "3f42",
	"./组 1393.png": "d9a9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c15";